import { render } from "./SideBySide.vue?vue&type=template&id=b2274e4c&scoped=true&lang=html"
import script from "./SideBySide.vue?vue&type=script&lang=js"
export * from "./SideBySide.vue?vue&type=script&lang=js"

import "./SideBySide.vue?vue&type=style&index=0&id=b2274e4c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b2274e4c"

export default script